import { useEffect, useState } from "react";
import Partials from "../partials";
import Blocks from "../blocks";
import UserEmail from "../../assets/images/user-email.svg";
import { useHistory, useParams } from "react-router-dom";

const PageVerifyEmail = () => {
    const [isVerified, setIsVerified] = useState(false);
    const { verifiedEmail } = useParams();
    const history = useHistory();

    useEffect(() => {
        if (!verifiedEmail || verifiedEmail === "undefined") {
            history.push('/');
        }
    }, [verifiedEmail, history]);

    const handleVerifyEmail = () => {
        try {
            // Open Gmail login page with the target email prefilled
            const gmailLoginUrl = `https://accounts.google.com/AccountChooser?Email=${encodeURIComponent(verifiedEmail)}&continue=https://mail.google.com`;
            window.open(gmailLoginUrl, '_blank', 'noopener,noreferrer');
        } catch (e) {
            // Fallback option
            window.open(`https://mail.google.com/mail/?authuser=${encodeURIComponent(verifiedEmail)}`, '_blank');
        }
    };

    return (
        <div className={'page PageVerifyEmail'}>
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row items-center">
                    <div className="bgWrapper md:flex flex-1 justify-center items-center bg-white">
                        <img src={UserEmail} alt="" draggable={false} />
                    </div>
                    <div className="pageContent w-full flex-1 text-center mx-auto md:mr-0 md:ml-auto mb-4 bg-white p-4 rounded-xl">
                        <Blocks.ErrorBoundary>
                            {isVerified ? (
                                <>
                                    <Partials.PartialSuccessIcon />
                                    <h3 className={"text-xl md:text-4xl mb-8 font-['Poppins-SemiBold']"}>Verified</h3>
                                    <p className={"text-md md:text-xl leading-loose mb-10"}>
                                        <span className={"leading-loose"}>
                                            Your email address has been verified.
                                        </span>
                                    </p>
                                    <button
                                        className="bg-black hover:bg-slate-600 text-white font-bold py-3 px-16 rounded focus:outline-none focus:shadow-outline"
                                        onClick={() => history.push('/teacher/complete-profile')}>
                                        Complete Profile
                                    </button>
                                </>
                            ) : (
                                <>
                                    <h3 className={"text-xl md:text-4xl mb-8 text-center md:text-left font-['Poppins-SemiBold']"}>
                                        Verify your email address
                                    </h3>
                                    <p className={"text-md md:text-xl text-center md:text-left mb-10"}>
                                        <span className={"leading-loose"}>
                                            You have entered {verifiedEmail} as your email address for your teacher&apos;s account.
                                        </span>
                                    </p>
                                    <button
                                        className="bg-black hover:bg-slate-600 text-white font-bold py-3 px-16 rounded focus:outline-none focus:shadow-outline"
                                        onClick={handleVerifyEmail}>
                                        Verify your Email
                                    </button>
                                </>
                            )}
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageVerifyEmail;